class StudioInfoDisclosure extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.details = this.querySelector('details');
    this.summary = this.details?.querySelector('summary');
    if (!this.summary) return;
    this.expanded = this.details.open;
    this.details.dataset.expanded = String(this.expanded);
    this.summary.addEventListener('click', event => {
      event.preventDefault();
      this.setExpanded(!this.expanded);
    }, { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.animation?.cancel();
  }

  setExpanded(expanded) {
    const start = this.details.getBoundingClientRect().height;
    this.animation?.cancel();
    this.expanded = expanded;
    this.details.dataset.expanded = String(expanded);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.details.open = expanded;
      return;
    }
    this.details.open = true;
    const border = parseFloat(getComputedStyle(this.details).borderTopWidth) + parseFloat(getComputedStyle(this.details).borderBottomWidth);
    const end = expanded ? this.details.getBoundingClientRect().height : this.summary.getBoundingClientRect().height + border;
    this.animation = this.details.animate([{ height: `${start}px` }, { height: `${end}px` }], { duration: 220, easing: 'cubic-bezier(.2,0,.2,1)' });
    this.animation.onfinish = () => {
      this.details.open = expanded;
      this.animation = null;
    };
  }
}
if (!customElements.get('studio-info-disclosure')) customElements.define('studio-info-disclosure', StudioInfoDisclosure);
